import { User } from './user.model';
import { ThirdPartyAdminister } from './third-party-administer.model';
import { HealthGorillaSettings } from './client-health-gorilla-settings.model';
import { EmrSystem } from './emr-system.model';

export class Client {
  id: number;
  name: string;
  fullName: string;
  humanizedName: string;
  claimIdentifierPrefix: string;
  hrsaIdStrings: string[] = [];
  allowedClientFileEhrInstanceValues: string[] = [];
  effectiveHrsaIdStrings: string[] = [];
  effectiveClaimIdentifierPrefixes: string[] = [];
  effectiveAllowedClientFileEhrInstanceValues: string[] = [];
  faxLocal: string;
  faxTollfree: string;
  patientOwnershipTimeframeInMonths: number;
  specialistEncounterTimeframeInMonths: number;
  outreachAttemptEvidenceTimeframeInMonths: number;
  status: string;
  invoicingTerms: string;
  invoicingTermsRate: number;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  logoUrl: string;
  directEnabled: boolean;
  directSendingAddress: string;
  directReceivingAddress: string;
  allowResearchDataSharing: boolean;
  goLiveDate: string;
  clientFileMonitoringEmailRecipients: string[];
  assignedUsers: User[] = [];
  liveThirdPartyAdministers: ThirdPartyAdminister[] = [];
  contractedThirdPartyAdministers: ThirdPartyAdminister[] = [];
  applicableToReferralClaims: boolean;
  applicableToIccClaims: boolean;
  superClientId: number;
  superClient: { id: number; humanizedName: string };
  entityTypes: string[] = [];
  inheritsIdentifiersFromSubClients: boolean;
  firstYearEstimatedValue: number;
  annualContractValue: number;
  adjustment: number;
  submittingToEsp: boolean;
  espSubmitStartDate: string;
  dateDealClosed: string;
  active: boolean;
  terminated: boolean;
  fileProcessingEnabled: boolean;
  outreachAttemptEvidenceEnabled: boolean;
  programMetricsLastUpdatedAt: Date;
  clientMetricsEnabled: boolean;
  humanEdited: boolean;
  healthGorillaSettings: HealthGorillaSettings;
  alternateWagBillingIdentifiers: string[];
  deactivationReason: string;
  deactivationAuthorDisplay: string;
  deactivatedAt: Date;
  fileProcessingDisabledAt: Date;
  fileProcessingDisabledByDisplay: string;
  expiringTaskEmailSentAt: Date;
  newTaskAndLocationsEmailSentAt: Date;
  emrSystems: EmrSystem[];
}
